import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "tab"]

  connect() {
    const defaultTab = this.tabTargets.find(
      tab => tab.dataset.locale === document.documentElement.lang
    ) || this.tabTargets[0]

    if (defaultTab) this.activate(defaultTab.dataset.locale, defaultTab)
  }

  selectLocale(event) {
    this.activate(event.target.dataset.locale, event.target)
  }

  activate(locale, activeTab) {
    this.tabTargets.forEach(tab => {
      tab.classList.toggle("border-b-2", tab === activeTab)
      tab.classList.toggle("border-blue-500", tab === activeTab)
      tab.classList.toggle("text-blue-600", tab === activeTab)
    })

    this.panelTargets.forEach(panel => {
      panel.classList.toggle("hidden", panel.dataset.locale !== locale)
    })
  }
}
